$(document).ready(function(){

  var feed = new Instafeed({
    get: 'user',
    userId: instaid,
    accessToken: instaaccesstoken,
    resolution: 'low_resolution',
    filter: function(image) {
      var MAX_LENGTH = 100;

      if (image.caption && image.caption.text) {
        image.short_caption = image.caption.text.slice(0, MAX_LENGTH) + '...';
      } else {
        image.short_caption = "";
      }

      return true;
    },
    limit: 12,
    template: `<a target="_blank" class="instagram-feed-item" href="{{link}}"><div class="instagram-feed-item-inner"><div class="instagram-feed-item-overlay"><div>{{model.short_caption}}</div></div><div class="instagram-feed-item-img" style="background-image:url('https://{{image}}');"></div></div></a>`
  });
  feed.run();

  var cntWd2 = $('.releases-cont').innerWidth();
  var tb2 = $('.releases-cont-inner');
  var sldWd2 = tb2.outerWidth();
  $('.releases-cont').mousemove(function(e){
    tb2.css({transform: "translateX(" + ((cntWd2 - sldWd2)*((e.pageX / cntWd2).toFixed(3))).toFixed(1) +"px)" });
  });


  $('.index-slider').slick({  
    dots: true,
    arrows: false,
    autoplay: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false
  });  


  //  $('a:not([href="#"]):not(".w-tab-link"):not([href="/cart"]):not([href^="#"])').click(function(event) {
  //    $('.footer').fadeOut();
  //   $('main').fadeOut();
  //  });

  $('select').niceSelect();


  var mywindow = $(window);
  var mypos = mywindow.scrollTop();
  var up = false;
  var newscroll;
  mywindow.scroll(function () {
    newscroll = mywindow.scrollTop();
    if (newscroll > mypos && !up) {
      $('.navbar').addClass('fadeout');
      $('.navbar').addClass('box');
      $('.collectionsorting-nav').addClass('fadeout');
      up = !up;
    } else if(newscroll < mypos && up) {
      $('.navbar').removeClass('fadeout');
      $('.navbar').addClass('box');
      $('.collectionsorting-nav').removeClass('fadeout');
      up = !up;
    }
    if (newscroll < 150){
      $('.navbar').removeClass('box');
    }
    mypos = newscroll;
  });


  var cntWd = $('.related-products-sec').innerWidth();
  var tb = $('.related-products-inner');
  var sldWd = tb.outerWidth();
  $('.related-products-sec').mousemove(function(e){
    tb.css({transform: "translateX(" + ((cntWd - sldWd)*((e.pageX / cntWd).toFixed(3))).toFixed(1) +"px)" });
  });




  $('.product-image-slider').slick({  
    dots: false,
    arrows: false,
    autoplay: false,
    asNavFor: '.product-thumbnail-slider',    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          dots: true
        }
      }
    ]
  });  
  $('.product-thumbnail-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product-image-slider',
    dots: false,
    arrows: false,
    focusOnSelect: true,
    vertical: true
  });
  $('.product-image-slider-hover.right').on('click', function(){
    $(".product-image-slider").slick('slickNext');
    $('.product-image-slider .slick-slide').css("transform", "translateX(0)");
  })
  .on('mousemove', function(e){
    var $this = $(this);
    var offset = $this.offset();
    var width = $this.width();
    var height = $this.height();
    var posX = offset.left;
    var posY = offset.top;
    var x = e.pageX-posX;
    x = parseInt(x/width*100,10);
    x = x<0?0:x;
    x = x>100?100:x;
    var y = e.pageY-posY;
    y = parseInt(y/height*100,10);
    y = y<0?0:y;
    y = y>100?100:y;
    $('.product-image-slider-hover-icon.right').css({top:y+'%', left:x+'%'}); 
  });
  $('.product-image-slider-hover.left').on('click', function(){
    $(".product-image-slider").slick('slickPrev');
    $('.product-image-slider .slick-slide').css("transform", "translateX(0)");
  })
  .on('mousemove', function(e){
    var $this = $(this);
    var offset = $this.offset();
    var width = $this.width();
    var height = $this.height();
    var posX = offset.left;
    var posY = offset.top;
    var x = e.pageX-posX;
    x = parseInt(x/width*100,10);
    x = x<0?0:x;
    x = x>100?100:x;
    var y = e.pageY-posY;
    y = parseInt(y/height*100,10);
    y = y<0?0:y;
    y = y>100?100:y;
    $('.product-image-slider-hover-icon.left').css({top:y+'%', left:x+'%'}); 
  });




  $('.releases-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    swipeToSlide: true,    
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  var collectionsortingbtm = ($('.footer').outerHeight(true)) + ($('.brand-releases-sec').outerHeight(true));
  $('.collectionsorting-nav').affix({
    offset: {
      bottom: collectionsortingbtm
    }
  });
  var viewportHeight = $('.index-slider').outerHeight();

  $('.index-slider').css({ height: viewportHeight });
  $('.index-slider .slide-inner').css({ height: viewportHeight });

});